import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane, faPhone, faEnvelope, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { Formik, FormikHelpers } from 'formik';
import * as Yup from 'yup';

interface ContactFormValues {
  name: string;
  email: string;
  phone: string;
  subject: string;
  message: string;
}

const ContactSection: React.FC = () => {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const initialValues: ContactFormValues = {
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  };

  const validationSchema = Yup.object({
    name: Yup.string().required('नाव आवश्यक आहे'),
    email: Yup.string().email('अवैध ईमेल पत्ता').required('ईमेल आवश्यक आहे'),
    phone: Yup.string().required('फोन नंबर आवश्यक आहे'),
    subject: Yup.string().required('विषय आवश्यक आहे'),
    message: Yup.string().required('संदेश आवश्यक आहे')
  });

  const handleSubmit = (
    values: ContactFormValues,
    { setSubmitting, resetForm }: FormikHelpers<ContactFormValues>
  ) => {
    setTimeout(() => {
      setFormStatus('success');
      setSubmitting(false);
      resetForm();

      setTimeout(() => {
        setFormStatus('idle');
      }, 5000);
    }, 1000);
  };

  return (
    <section className="section" id="contact">
      <Container>
        <h2 className="section-title">आमच्याशी संपर्क साधा</h2>
        <p className="section-subtitle">आमच्या टीमशी संपर्क साधा</p>

        <Row className="mt-5">
          <Col lg={5} className="mb-4 mb-lg-0">
            <h4 className="mb-4">संपर्क माहिती</h4>
            <p>
              आमच्या सेवांबद्दल कोणतेही प्रश्न असतील तर आम्हाला सांगायला विसरू नका. आम्ही लवकरच उत्तर देऊ.
            </p>

            <div className="contact-info mt-4">
              <div className="d-flex mb-3">
                <div className="me-3">
                  <FontAwesomeIcon icon={faMapMarkerAlt} size="lg" className="text-primary" />
                </div>
                <div>
                  <h5 className="mb-1">पत्ता</h5>
                  <p className="mb-0">जीवन आधार विमा सेवा केंद्र,टेंभुर्णी,413211,महाराष्ट्र</p>
                </div>
              </div>

              <div className="d-flex mb-3">
                <div className="me-3">
                  <FontAwesomeIcon icon={faPhone} size="lg" className="text-primary" />
                </div>
                <div>
                  <h5 className="mb-1">फोन</h5>
                  <p className="mb-0">+91 9881665741</p>
                </div>
              </div>

              <div className="d-flex mb-3">
                <div className="me-3">
                  <FontAwesomeIcon icon={faEnvelope} size="lg" className="text-primary" />
                </div>
                <div>
                  <h5 className="mb-1">ईमेल</h5>
                  <p className="mb-0">kishorsalgar55100@gmail.com</p>
                </div>
              </div>
            </div>

            <div className="mt-4">
              <h4 className="mb-3">व्यवसायाचे वेळापत्रक</h4>
              <p className="mb-2">सोमवार - शुक्रवार: सकाळी ९:०० ते संध्याकाळी ६:००</p>
              <p className="mb-0">शनिवार: सकाळी ९:०० ते दुपारी १:००</p>
            </div>
          </Col>

          <Col lg={7}>
            <div className="contact-form-container p-4 bg-light-gray rounded">
              <h4 className="mb-4">संदेश पाठवा</h4>

              {formStatus === 'success' && (
                <Alert variant="success" className="mb-4">
                  तुमचा संदेश यशस्वीरित्या पाठवण्यात आला आहे! आम्ही लवकरच संपर्क करू.
                </Alert>
              )}

              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting
                }) => (
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col md={6} className="mb-3">
                        <Form.Group>
                          <Form.Label>नाव</Form.Label>
                          <Form.Control
                            type="text"
                            name="name"
                            value={values.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={touched.name && !!errors.name}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.name}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={6} className="mb-3">
                        <Form.Group>
                          <Form.Label>ईमेल</Form.Label>
                          <Form.Control
                            type="email"
                            name="email"
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={touched.email && !!errors.email}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.email}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6} className="mb-3">
                        <Form.Group>
                          <Form.Label>फोन</Form.Label>
                          <Form.Control
                            type="text"
                            name="phone"
                            value={values.phone}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={touched.phone && !!errors.phone}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.phone}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={6} className="mb-3">
                        <Form.Group>
                          <Form.Label>विषय</Form.Label>
                          <Form.Control
                            type="text"
                            name="subject"
                            value={values.subject}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={touched.subject && !!errors.subject}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.subject}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Form.Group className="mb-4">
                      <Form.Label>संदेश</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={5}
                        name="message"
                        value={values.message}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.message && !!errors.message}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.message}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <div className="text-center">
                      <Button
                        type="submit"
                        variant="primary"
                        size="lg"
                        disabled={isSubmitting}
                      >
                        <FontAwesomeIcon icon={faPaperPlane} className="me-2" />
                        {isSubmitting ? 'पाठवत आहे...' : 'संदेश पाठवा'}
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ContactSection;
